import { errors } from 'redux-rest-reducer';
import { getCookie } from 'utils';
import { ACTIONS as loginActions } from 'actions/login';
import { ACTIONS as logoutActions } from 'actions/logout';

const accessToken = getCookie('access_token');
const externalUserId = getCookie('user_id');
// TODO (Attri): move isStaff flow to a separate permissions reducer

export const initialState = {
  loggedIn: !!accessToken,
  isStaff: !externalUserId,
};

export default function(state = initialState, { type }) {
  if (type === loginActions.POST_SUCCESS) {
    return {
      loggedIn: true,
      isStaff: false,
    };
  }

  if (type === logoutActions.POST_SUCCESS || type === errors[401]) {
    return {
      ...state,
      loggedIn: false,
    };
  }
  return state;
}
